import { render, staticRenderFns } from "./Clinics.vue?vue&type=template&id=eaba62fe&scoped=true"
import script from "./Clinics.vue?vue&type=script&lang=js"
export * from "./Clinics.vue?vue&type=script&lang=js"
import style0 from "./Clinics.vue?vue&type=style&index=0&id=eaba62fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaba62fe",
  null
  
)

export default component.exports